// developed by Param Partap Singh
import React, { useState } from "react";
import logo from "../Assets/logo.png";
import { Link } from "react-router-dom";
import "../Css/Nav.css";


export default function Nav() {
  
    const [upermenuopen, setupermenuopen] = useState(false);

  return (

       <div className="dept-header-inner-nav">
        <section className="dept-brand-bar">
          <img className="dept-inst-logo" src={logo} alt="Institute Logo"/>
          <a className="dept-icon-name a" href="#">
            Indian Institute of Technology Ropar
          </a>
          <nav id="dept-gateway" className={upermenuopen ? "dept-open" : ""}>
            <ul className="dept-gateway-ul">
                <Link  to="/" onClick={() => upermenuopen}><li>Our Services</li></Link>
              
                <Link to="/start"  onClick={() => upermenuopen} ><li>Getting Started</li></Link>
          
                <Link to="/application" onClick={() => upermenuopen}><li>Applications</li></Link>
              
              
                <Link to="/network" onClick={() => upermenuopen}><li>Network Services</li></Link>
              
              
                <li><Link  to="/cloud" onClick={() => upermenuopen}>Servers
                  </Link></li>

                <li><Link  to="/eduroam" onClick={() => upermenuopen}>Eduroam
                  </Link></li>
              
                <Link to="/police" onClick={() => upermenuopen}><li>Policies</li></Link>
              
             
                <Link to="/software" onClick={() => upermenuopen}> <li>Software</li></Link>
              
              
                <Link to="/about" onClick={() => upermenuopen}><li>About Us</li></Link>
              
            </ul>
          </nav>
          <div
            className="dept-ham"
            onClick={() => {
              setupermenuopen(!upermenuopen);
            }}
          >
            <div className="dept-bar"></div>
            <div className="dept-bar"></div>
            <div className="dept-bar"></div>
          </div>
        </section>
      
      </div>
  
  );
}

